export default __webpack_public_path__ + "static/media/chevron_leftCalendarIcon.e9d42291.svg";